import { GetterTree } from 'vuex';
import ILocalState from './stateInterface';
import Jsona from 'jsona';
import { ProjectListItem } from '@/interfaces/ProjectListItem';

const dataFormatter = new Jsona();

const getters: GetterTree<ILocalState, {}> = {
    myProjectsList(state) {
        if (!state.myProjectsList) {
            return [];
        }
        const deserializedData = dataFormatter.deserialize(
            state.myProjectsList,
        ) as ProjectListItem[];
        deserializedData.forEach((projectItem) => {
            projectItem.edit = false;
        });
        return deserializedData;
    },
    activeProject(state) {
        if (!state.activeProject) {
            return null;
        }
        return dataFormatter.deserialize(state.activeProject);
    },
    allProjectItems(state) {
        if (!state.allProjectItems) {
            return null;
        }
        return dataFormatter.deserialize(state.allProjectItems);
    },
    activeSingleReport(state) {
        if (!state.activeSingleReport) {
            return null;
        }
        return dataFormatter.deserialize(state.activeSingleReport);
    },
    projectOverview(state) {
        if (!state.projectOverview) {
            return null;
        }
        return dataFormatter.deserialize(state.projectOverview);
    },
};

export default getters;
